import React from "react";
import ReactMarkdown from "react-markdown";
import { useTranslation } from "react-i18next";
import "./styles.scss";

function MarkdownPolicyEditor({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  const { t } = useTranslation();

  return (
    <div className="markdown-policy-editor">
      <div className="markdown-policy-editor__pane">
        <div className="markdown-policy-editor__label">
          {t("sidebar.organization.markdown")}
        </div>
        <textarea
          className="markdown-policy-editor__source"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          spellCheck={false}
        />
      </div>
      <div className="markdown-policy-editor__pane">
        <div className="markdown-policy-editor__label">
          {t("sidebar.organization.preview")}
        </div>
        <div className="markdown-policy-editor__preview">
          {value.trim() ? (
            <ReactMarkdown>{value}</ReactMarkdown>
          ) : (
            <p className="markdown-policy-editor__empty">
              {t("sidebar.organization.previewEmpty")}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default MarkdownPolicyEditor;
